module.exports = __webpack_public_path__ + "img/img-cate3.b3073efe.webp";